// A person's files from the old SmartSearch archive (shown on the participant page when there are any).
import { useState } from 'react';
import { useData } from '../lib/useData.ts';
import { ArchiveViewer, STATUS_LABEL, type ArchiveRow } from '../pages/Archive.tsx';
import { ErrorBox } from './Layout.tsx';

export function ArchiveFilesCard({ participantId }: { participantId: string }) {
  const { data, error } = useData<ArchiveRow[]>(`/api/participants/${participantId}/archive`);
  const [open, setOpen] = useState<string | null>(null);
  if (error) return <ErrorBox error={error} />;
  if (!data?.length) return null;
  return (
    <div className="card">
      <h2 style={{ marginTop: 0 }}>Old SmartSearch files <span className="muted small">({data.length})</span></h2>
      <div className="table-scroll"><table>
        <thead><tr><th>Date</th><th>Department</th><th>Label</th><th></th></tr></thead>
        <tbody>{data.map((d) => (
          <tr key={d.id} className={`link${open === d.id ? ' selected' : ''}`} onClick={() => setOpen(open === d.id ? null : d.id)}>
            <td className="nowrap">{d.docDate ? `${d.docDate.slice(5, 7)}/${d.docDate.slice(8, 10)}/${d.docDate.slice(0, 4)}` : d.year ?? '—'}</td>
            <td>{d.departmentText ?? '—'}</td>
            <td>{d.label ?? ''}</td>
            <td className="muted small">{d.status === 'auto' ? '' : STATUS_LABEL[d.status]}</td>
          </tr>))}</tbody>
      </table></div>
      {open && <div style={{ marginTop: '0.75rem' }}><ArchiveViewer id={open} /></div>}
    </div>
  );
}
